import { Box, Typography } from "@mui/material";
import styles from './TitleSubtitle.module.scss';

interface Props {
    title?: string;
    subTitle?: string;
    useMarkdown?: boolean;
}

export default function TitleSubtitle ({title, subTitle, useMarkdown}: Props){
    return (
        <Box className={styles.container}>
            {title && (useMarkdown ? (<p className={styles.title}>{title}</p>) : (<Typography className={styles.title}>
                {title}
            </Typography>))}

            {subTitle && (useMarkdown ? (<p className={styles.subtitle}>{subTitle}</p>) : (<Typography className={styles.subtitle}>
                {subTitle}
            </Typography>))}
        </Box>
    );
}